import { FormHelperText, Grid } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { useFormControl, formControlState } from '../..';

const styles = () => ({
  readOnly: {
    display: 'none',
  },
});

const BaseInputErrorText = (props) => {
  const { errors = [], ...rest } = props;

  const contextProps = useFormControl();

  const fcs = formControlState({
    props,
    ctxProps: contextProps,
    states: ['readOnly', 'error', 'required', 'disabled'],
  });

  const hasErrors = errors.length > 0;

  return !fcs.readOnly && hasErrors ? (
    <FormHelperText component="div" {...fcs} {...rest}>
      <Grid container direction="column">
        {errors.map((error) => (
          <Grid key={error} item component="span">
            {error}
          </Grid>
        ))}
      </Grid>
    </FormHelperText>
  ) : null;
};

const StyledBaseInputErrorText = withStyles(styles)(BaseInputErrorText);

export { StyledBaseInputErrorText as BaseInputErrorText };
